'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPLITTER = undefined;
exports.clearSplitter = clearSplitter;

exports.default = function (docs) {
  var normalized = Array.isArray(docs) ? [].concat(_toConsumableArray(docs)) : [docs];

  var grouped = normalized.reduce(function (docs, doc) {
    var _transformEmojis$spli = (0, _transformEmojis2.default)(doc).split(SPLITTER),
        _transformEmojis$spli2 = _toArray(_transformEmojis$spli),
        docsBeforePreview = _transformEmojis$spli2[0],
        docsAfterPreview = _transformEmojis$spli2.slice(1);

    if (!docsAfterPreview || docsAfterPreview.length === 0) {
      docs.docsAfterPreview.push(docsBeforePreview);
    } else {
      var _docs$docsAfterPrevie;

      docs.docsBeforePreview.push(docsBeforePreview);
      (_docs$docsAfterPrevie = docs.docsAfterPreview).push.apply(_docs$docsAfterPrevie, _toConsumableArray(docsAfterPreview));
    }

    return docs;
  }, {
    docsBeforePreview: [],
    docsAfterPreview: []
  });

  return {
    docsBeforePreview: grouped.docsBeforePreview.length === 0 ? null : grouped.docsBeforePreview.map(_marked2.default),
    docsAfterPreview: grouped.docsAfterPreview.length === 0 ? null : grouped.docsAfterPreview.map(_marked2.default)
  };
};

var _transformEmojis = require('./transformEmojis');

var _transformEmojis2 = _interopRequireDefault(_transformEmojis);

var _marked = require('./marked');

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SPLITTER = exports.SPLITTER = '<!-- STORY -->';

function clearSplitter(docs) {
  return docs.map(function (doc) {
    return doc.replace(SPLITTER, '');
  });
}